import type {
    CoverableChangesDTO,
    DiffDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';

interface opcAttributeChangeParam {
    type: 'attribute';
    attributeFieldName: string;
}

interface opcCoverageChangeParam {
    type: 'coverage';
    coverageId: string;
}

interface opcTermChangeParam {
    type: 'term';
    coverageId: string;
    termId: string;
}

const getCoverableDiffsDTO = (
    coverableChangesDTO: CoverableChangesDTO[],
    linePrefix: string,
    fixedId: string
): DiffDTO[] => {
    return (
        coverableChangesDTO.find(
            (coverableChange) =>
                coverableChange.linePrefix === linePrefix && coverableChange.coverableId === fixedId
        )?.changes ?? []
    );
};

const isChangeTypeAvailable = (
    changeTypeInfo: opcAttributeChangeParam | opcCoverageChangeParam | opcTermChangeParam,
    changesDTO: DiffDTO[]
): boolean => {
    if (changeTypeInfo.type === 'attribute') {
        return changesDTO.some(
            (change) =>
                change.type === 'attribute' &&
                change.attributeFieldName === changeTypeInfo.attributeFieldName
        );
    }

    if (changeTypeInfo.type === 'coverage') {
        return changesDTO.some(
            (change) =>
                change.type === 'coverage' && change.coverageId === changeTypeInfo.coverageId
        );
    }

    return changesDTO.some(
        (change) =>
            change.type === 'term' &&
            change.coverageId === changeTypeInfo.coverageId &&
            change.termId === changeTypeInfo.termId
    );
};

export { getCoverableDiffsDTO, isChangeTypeAvailable };
